export default "__VITE_ASSET__i47CwVkF__"